import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type Board } from '@air/api/types';
import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicExtensionsList } from '~/swr-hooks/filters/usePublicExtensionsList';

type PublicExtensionsSelectProps = {
  boardId: Board['id'] | undefined;
} & BaseStringSelectProps;

export const PublicExtensionsSelect = memo(({ boardId, ...props }: PublicExtensionsSelectProps) => {
  const { shortId } = useShortIdContext();
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicExtensionsList({
    search: debouncedSearchValue,
    shortId,
    boardId,
  });

  return (
    <StringSelect
      id="extension"
      placeholder="Search for extensions"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicExtensionsSelect.displayName = 'PublicExtensionsSelect';
